import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch } from "react-redux";
import { DatePicker, Modal } from "rsuite";
import { useAppSelector } from "../../core/redux";
import { ActionsModal } from "../../core/redux/slices/sliceModal";
import { EnumModals } from "../../libs";
import { Button } from "../button.component";
import { ModalData } from "./ModalData";

function InvoiceDownloadModalComponent() {
  const Data = ModalData.InvoiceDownloadModal;
  const store = useAppSelector(
    (state) => ({
      show: state.modal.openedModals.includes(
        EnumModals.INVOICE_DOWNLOAD_MODAL
      ),
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const [selectedYearMonth, setSelectedYearMonth] = useState<Date>();

  const handleClose = () => {
    dispatch(ActionsModal.hideModal(EnumModals.INVOICE_DOWNLOAD_MODAL));
  };

  const startDate = new Date(Data.startDate!);
  const endDate = new Date(Data.endDate!);

  const comparableStartDate = new Date(
    startDate.getFullYear(),
    startDate.getMonth()
  );
  const comparableEndDate = new Date(endDate.getFullYear(), endDate.getMonth());

  const isValidStartDate = (date?: Date) => {
    if (!date) return false;
    const comparableDate = new Date(date.getFullYear(), date.getMonth());
    if (comparableDate < comparableStartDate) return false;
    if (comparableDate > comparableEndDate) return false;
    return true;
  };

  const handleDownload = () => {
    if (!selectedYearMonth) return;
    const yearMonth = new Date(
      selectedYearMonth.getFullYear(),
      selectedYearMonth.getMonth()
    );
    Data.handleDownload?.(yearMonth);
  };

  useEffect(() => {
    if (!store.show) {
      Data.OkButtonText = "Download";
    }
  }, [store.show, Data]);

  return (
    <Modal open={store.show}>
      <Modal.Body className="m-0">
        <div className="row g-0 ">
          <div className="col-12 text-end">
            <span onClick={handleClose}>
              <i className="fa fa-times click" />
            </span>
          </div>
        </div>
        <div>
          <div className="row g-0">
            <div className="col">
              <span>Year-Month : </span>
              <DatePicker
                format="yyyy-MM"
                disabledDate={(date?: Date) => !isValidStartDate(date)}
                onChange={setSelectedYearMonth}
              />
            </div>
            <div className="col">
              <div>
                <Button
                  className="m-1 w-100 btn-green"
                  loading={false}
                  disabled={!selectedYearMonth}
                  onClick={handleDownload}
                  name={Data.OkButtonText || "Download"}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export const InvoiceDownloadModal = React.memo(InvoiceDownloadModalComponent);
